"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Install';
exports.packageGroup = 'install';
exports.apiPathGroup = 'install';
exports.routerPathGroup = 'install';
